import SeamlessIntegrations from "assets/images/Seamless-Integrations.svg";

export default function SeamlessIntegrationSection() {
    return (
        <section className="workflow-section flex-column d-flex items-center justify-center">
            <div className="workflow-scroll-element" />
            <h2 className="features-title">Seamless Integrations</h2>
            <div className="custom-container d-flex items-center width-100">
                <div className="integration-image-placeholder d-flex items-center justify-center">
                    <img src={SeamlessIntegrations} alt="Seamless Integrations" />
                </div>

                <div className="workflow-steps-integration d-flex flex-column">
                    <div className="workflow-step-integration-card">
                        <div>
                            <div className="workflow-step-title">California Lottery</div>
                            <div className="workflow-step-desc">Direct integration with SmartCount reports and daily sales summaries. Automatic data synchronization and batch processing.</div>
                        </div>
                    </div>
                    <div className="workflow-step-integration-card">
                        <div>
                            <div className="workflow-step-title">POS Systems</div>
                            <div className="workflow-step-desc">Connect your point-of-sale system to automatically pull lottery sales data and cross-reference with ticket counts.</div>
                        </div>
                    </div>
                    <div className="workflow-step-integration-card">
                        <div>
                            <div className="workflow-step-title">SMS Notifications</div>
                            <div className="workflow-step-desc">Receive real-time alerts via SMS for inventory discrepancies, audit completions, and important updates.</div>
                        </div>
                    </div>
                    <div className="workflow-step-integration-card">
                        <div>
                            <div className="workflow-step-title">Barcode Scanners</div>
                            <div className="workflow-step-desc">Optional barcode scanner support for quick pack activation and inventory spot-checks.</div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}